document.addEventListener('DOMContentLoaded', function () {
  const selector = document.querySelector('vehicle-model-selector');
  const specifications = document.querySelectorAll('.vehicle-specifications');
  const dimensionMarkers = document.querySelectorAll('.marker__wrapper');
  const defaultContent = document.getElementById('default-content');

  function hideAll() {
    specifications.forEach((spec) => (spec.style.display = 'none'));
    // dimensionMarkers.forEach((marker) => (marker.style.display = 'none'));
    defaultContent.style.display = 'none';
  }

  // Call the function when the page loads
  hideAll();

  function showImages(selectedValue) {
    hideAll();
    if (!selectedValue) {
      showDefaultContent();
    } else {
      const selectedLink = selector.querySelector(`.disclosure__link[data-value="${selectedValue}"]`);
      if (selectedLink) {
        const optionText = selectedLink.textContent.trim();
        displayElements(selectedLink, optionText);
        applyHoverEffects();
      }
    }
  }

  function showDefaultContent() {
    document.querySelectorAll('[data-vehicle="default"]').forEach((element) => {
      element.style.display = 'block';
    });
  }

  function displayElements(selectedLink, optionText) {
    const handleizedOptionText = handleize(optionText);
    const vehicleImage = document.querySelector(`[image="vehicle"][data-vehicle="${handleizedOptionText}"]`);
    const camperImage = document.querySelector(`[image="camper"][data-vehicle="${handleizedOptionText}"]`);
    const tent1Image = document.querySelector(`[image="tent1"][data-vehicle="${handleizedOptionText}"]`);
    const tent2Image = document.querySelector(`[image="tent2"][data-vehicle="${handleizedOptionText}"]`);
    const hardwareImage = document.querySelector(`[image="hardware"][data-vehicle="${handleizedOptionText}"]`);
    const specification = document.querySelector(`.vehicle-specifications--${handleizedOptionText}`);

    if (vehicleImage) vehicleImage.style.display = 'block';
    if (camperImage) camperImage.style.display = 'block';
    if (tent1Image) tent1Image.style.display = 'block';
    if (tent2Image) tent2Image.style.display = 'block';
    if (hardwareImage) hardwareImage.style.display = 'block';
    if (specification) specification.style.display = 'block';

    document.querySelectorAll(`.marker--${handleizedOptionText}`).forEach((marker) => {
      marker.style.display = 'block';
    });
  }

  function applyHoverEffects() {
    const markers = document.querySelectorAll('.marker');
    const specifications = document.querySelectorAll('.specification');

    markers.forEach((marker) => {
      marker.onmouseover = () => toggleHighlight(marker, true);
      marker.onmouseout = () => toggleHighlight(marker, false);
    });

    specifications.forEach((spec) => {
      spec.onmouseover = () => toggleHighlight(spec, true);
      spec.onmouseout = () => toggleHighlight(spec, false);
    });
  }

  function toggleHighlight(element, add) {
    const targetId = element.getAttribute('data-target-id');
    const targetSpec = document.querySelectorAll(`.specification[data-target-id="${targetId}"]`);
    const targetMarkers = document.querySelectorAll(`.marker[data-target-id="${targetId}"]`);

    targetSpec.forEach((spec) => {
      spec.classList.toggle('specification-highlight', add);
    });
    targetMarkers.forEach((marker) => {
      marker.classList.toggle('marker-highlight', add);
    });
  }

  selector.addEventListener('change', function (event) {
    const selectedValue = event.detail.value;
    const selectedVehicleSize = event.target
      .querySelector(`[data-value="${selectedValue}"]`)
      .getAttribute('data-vehicle-size');
    showImages(selectedValue, selectedVehicleSize);
  });

  // Set initial state
  const initialSelectedLink = selector.querySelector('.disclosure__link[aria-selected="true"]');
  if (initialSelectedLink) {
    showImages(initialSelectedLink.dataset.value);
  } else {
    showDefaultContent();
  }
});
